import { useCallback, useEffect, useState } from "react";

export interface Me {
  user: { id: string; name: string; email: string; image: string | null };
  activeOrganizationId: string | null;
  organizations: { organizationId: string; role: string; name: string; slug: string }[];
}

/** The signed-in user and their teams; `me` is null when signed out. */
export function useMe() {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try {
      const res = await fetch("/api/me", { credentials: "include" });
      setMe(res.ok ? await res.json() : null);
    } catch { setMe(null); }
    setLoading(false);
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { me, loading, refresh };
}
